import React from 'react';
import PropTypes from 'prop-types';

const Strings = require('../../../../../app/shared/Strings');

export function DeleteTagWarning(props) {
    return (
        <div className={props.className}>
            Are you sure you want to delete this tag? This tag is currently attached to {props.attachedActCount} {props.attachedActCount === 1 ? 'activity' : 'activities'}.
        </div>
    );
}

export function DeleteTypeWarning(props) {
    return (
        <div className={props.className}>
            Are you sure you want to delete this type? This type is currently attached to {props.attachedActCount} {props.attachedActCount === 1 ? 'activity' : 'activities'}.
        </div>
    );
}

DeleteTagWarning.propTypes = { className: PropTypes.string, attachedActCount: PropTypes.number.isRequired };
DeleteTagWarning.defaultProps = { className: '' };

export function ImportTagsInfo(props) {
    return (
        <div className={props.className}>
            <p className="margin-bottom-md">
                Importing tags will <strong className="font-weight-bold">merge</strong> the tags present in the imported file with existing Activity Meta Tags in the <strong className="font-weight-bold">{props.categoryName} category</strong>.
                After importing, you will be prompted to confirm all pending changes before changes are finalized. 
                Once changes are finalized, they <strong className="font-weight-bold">cannot be automatically undone</strong>. 
                Tag file size limit is 3Mb.
            </p>
            <ul className="listBulletIndent__spacedSm">Imported files will be interpreted using these rules:
                {(props.requiresOrder) ?
                    <li>The first row of the imported file must have the column headings: <strong className="font-weight-bold font-style-italic">{Strings['en'].act_meta_tags.DISPLAY_ORDER}</strong> and <strong className="font-weight-bold font-style-italic">{Strings['en'].act_meta_tags.TAG_NAME}</strong></li>
                    :
                    <li>The first row of the imported file must have the column heading: <strong className="font-weight-bold font-style-italic">{Strings['en'].act_meta_tags.TAG_NAME}</strong></li>
                }
                <li>Imported tag rows with a <em className="font-style-italic">{Strings['en'].act_meta_tags.TAG_NAME}</em> that does not match an existing tag will be <strong className="font-weight-bold">added</strong></li>
                {/*<li>Existing Integration Tags that have a tag name not present in the imported file will be <span className="font-weight-bold">deleted</span></li>*/}
                {(props.requiresOrder) &&
                    <li>Imported tag rows with a matching <em className="font-style-italic">{Strings['en'].act_meta_tags.TAG_NAME}</em> but a different <em className="font-style-italic">{Strings['en'].act_meta_tags.DISPLAY_ORDER}</em> will be <strong className="font-weight-bold">updated</strong> with the new <em className="font-style-italic">{Strings['en'].act_meta_tags.DISPLAY_ORDER}</em>.</li>
                }
                {(props.requiresOrder) ?
                    <li>Imported tag rows with a matching <em className="font-style-italic">{Strings['en'].act_meta_tags.TAG_NAME}</em> and matching <em className="font-style-italic">{Strings['en'].act_meta_tags.DISPLAY_ORDER}</em> <strong className="font-weight-bold">will not alter</strong> the existing tag</li>
                    :
                    <li>Imported tag rows with a matching <em className="font-style-italic">{Strings['en'].act_meta_tags.TAG_NAME}</em> <strong className="font-weight-bold">will not alter</strong> the existing tag</li>
                }
                {(props.requiresOrder) &&
                    <li>Each imported tag row must contain a <strong className="font-weight-bold">unique</strong> <em className="font-style-italic">{Strings['en'].act_meta_tags.DISPLAY_ORDER}</em></li>
                }
                {(props.requiresOrder) &&
                    <li>Valid <em className="font-style-italic">{Strings['en'].act_meta_tags.DISPLAY_ORDER}</em> values are <strong className="font-weight-bold">integers, greater than or equal to zero</strong></li>
                }
            </ul>
        </div>
    );
}

ImportTagsInfo.propTypes = { className: PropTypes.string, requiresOrder: PropTypes.bool.isRequired, categoryName: PropTypes.string.isRequired };
ImportTagsInfo.defaultProps = { className: '' };


export function ExportTagsInfo(props) {
    return (
        <div className={props.className}>
            <p className="margin-bottom-sm">
                <span>Exporting tags will generate a CSV file containing all current Activity Meta Tags for the <strong className="font-weight-bold">{props.categoryName} category</strong>. </span>
                {(props.requiresOrder) &&
                    <span>Activity Meta Tag names will be paired with their matching display order. </span>
                }
                <span>The exported file may be edited and used with the Import Tags feature.</span>
            </p>
            <p>
                <span className="font-weight-bold">Note:</span> Use caution when editing CSV files using spreadsheet programs. 
                Spreadsheet programs may interpret tag names as <span className="font-style-italic">numbers</span> which may result in automatic formatting and data loss.
            </p>
        </div>
    );
}

ExportTagsInfo.propTypes = { className: PropTypes.string, requiresOrder: PropTypes.bool.isRequired, categoryName: PropTypes.string.isRequired };
ExportTagsInfo.defaultProps = { className: '' };


export function TagNameInfo(props) {
    return (
        <div className={props.className}>
            <p>
                <strong className="font-weight-bold">Note:</strong> Leading and trailing whitespace will automatically be trimmed from {Strings['en'].act_meta_tags.TAG_NAME}.
            </p>
        </div>
    );
}

TagNameInfo.propTypes = { className: PropTypes.string };
TagNameInfo.defaultProps = { className: '' };